import gql from 'graphql-tag';

import type { TaskResponse } from 'common/components/TasksWidget/queries';
import { TaskFragment } from 'common/components/TasksWidget/queries';

export const SUBSCRIBED_TASKS_PAGE_SIZE = 20;

export const getSubscribedTasks = gql`
  query getSubscribedTasks($id: [BinaryId!], $fetch: Boolean!, $sync: Boolean!) {
    me {
      id
      tasks: recentTasks(limit: 20) @include(if: $fetch) {
        ...Task
      }

      sync: tasks(id: $id) @include(if: $sync) {
        ...Task
      }
    }
  }

  ${TaskFragment}
`;

export type SubscribedTasksResponse = {
  me: {
    tasks: TaskResponse[];
    sync: TaskResponse[];
  };
};
